
export function searchWord (search, data) {
  const words = search.toLowerCase().split(' ')

  return words.every(word => {
    const regex = new RegExp(normalize(escapeRegExp(word)), 'gi')
    return normalize(data).match(regex)
  })
}

export function normalize (data) {
  return data.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

function escapeRegExp (str) {
  // eslint-disable-next-line
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
